export type AgentCapability = {
  id: string;
  labelEn: string;
  labelZh: string;
  description: string;
};

export type BuilderCapability = {
  title: string;
  description: string;
};

export type ClawCapability = {
  title: string;
  description: string;
};

export type RaasRow = {
  dimension: string;
  traditional: string;
  raas: string;
};

export type RaasPromise = {
  title: string;
  description: string;
};

export const agentCapabilities: AgentCapability[] = [
  {
    id: "agentic",
    labelEn: "AGENTIC",
    labelZh: "自主驱动",
    description:
      "主动识别高意向客户、自主推荐方案、自动追单与复购召回，不靠人工触发。",
  },
  {
    id: "multimodal",
    labelEn: "MULTIMODAL",
    labelZh: "多模态理解",
    description:
      "读懂图片 / 语音 / 视频 / 文档，准确理解客户的真实需求与情绪。",
  },
  {
    id: "memory",
    labelEn: "MEMORY-NATIVE",
    labelZh: "长程记忆",
    description:
      "原生记忆每个客户的偏好、历史订单、对话上下文，沟通永远「接得上」。",
  },
  {
    id: "mcp",
    labelEn: "MCP-NATIVE",
    labelZh: "工具编排",
    description:
      "原生支持 MCP 协议，可主动调用 ERP/CRM/电商/支付/物流系统完成交易闭环。",
  },
  {
    id: "omni",
    labelEn: "OMNICHANNEL",
    labelZh: "全渠道在线",
    description:
      "同一个销冠人格，跨 20+ 渠道无缝出现，客户不会感到「被换人」。",
  },
  {
    id: "247",
    labelEn: "24-7 MULTILINGUAL",
    labelZh: "全天候多语言",
    description:
      "7×24 不下班 + 多语言原生支持，跨境 / 时区 / 节假日全覆盖。",
  },
];

export const builderCapabilities: BuilderCapability[] = [
  {
    title: "描述即交付",
    description:
      "一句业务描述，自动生成销冠话术 + 工作流，无需任何代码或培训。",
  },
  {
    title: "5 大行业模板",
    description:
      "电商与零售 / 金融与科技 / 大健康 / 本地生活 / 教培开箱即用，按需可深度定制。",
  },
  {
    title: "持续进化",
    description: "根据真实成交数据自动迭代话术，越用越懂你的客户。",
  },
];

export const clawCapabilities: ClawCapability[] = [
  {
    title: "全渠道触达",
    description:
      "微信（企微/个微/公众号）/ 抖音 / 小红书 / WhatsApp / IG / Telegram / Shopify…",
  },
  {
    title: "全场景成交",
    description:
      "咨询 / 下单 / 支付 / 物流 / 售后 / 复购召回——一条龙闭环，不用人工接力。",
  },
  {
    title: "MCP 原生编排",
    description:
      "可被销冠主动调用的 ERP / CRM / 电商 / 支付 / 物流系统集成池。",
  },
];

export const raasRows: RaasRow[] = [
  {
    dimension: "交付物",
    traditional: "软件账号 / 席位",
    raas: "每月新增成交订单",
  },
  {
    dimension: "付费方式",
    traditional: "按席位 / 按 Token",
    raas: "按成交效果 / 订阅",
  },
  {
    dimension: "上线周期",
    traditional: "2-8 周培训 + 配置",
    raas: "3 分钟生成销冠 · 当天上岗",
  },
  {
    dimension: "服务时间",
    traditional: "工作时间 9-18",
    raas: "24/7 Always-on",
  },
  {
    dimension: "渠道覆盖",
    traditional: "3-5 个主流渠道",
    raas: "20+ 社交电商渠道原生接入",
  },
  {
    dimension: "效果责任",
    traditional: "客户自负 KPI",
    raas: "14 天产能保证",
  },
];

export const raasPromises: RaasPromise[] = [
  {
    title: "3 分钟上岗",
    description: "从描述业务到销冠开始接客，全程 ≤ 3 分钟。",
  },
  {
    title: "14 天产能保证",
    description: "14 天内未达约定产能基线，免费延期或退款。",
  },
  {
    title: "7×24 Always-on",
    description: "不下班、不漏单、不漏复购，每一条线索都被接住。",
  },
];

export const roleCards = [
  {
    name: "3Chat Agent",
    tag: "大脑 · 在前线作战",
    body: "具备自主性 / 长程记忆 / 多模态理解 / MCP 编排能力的 AI 销冠。",
  },
  {
    name: "3Chat Builder",
    tag: "生产线 · 生成销冠",
    body: "3 分钟内根据业务描述生成专属 Agent，无需技术、按需迭代。",
  },
  {
    name: "3Chat Claw",
    tag: "手脚 · 接管渠道",
    body: "原生接入 20+ 社交电商 + 业务系统，让销冠真正「出手」成交。",
  },
] as const;
